import { render, staticRenderFns } from "./double-time.vue?vue&type=template&id=3c47f686"
import script from "./double-time.vue?vue&type=script&lang=js"
export * from "./double-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports